import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import dayjs from "dayjs";

import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { LocalizationProvider } from "@mui/x-date-pickers-v6/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers-v6/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers-v6/AdapterDayjs";

import CloseIcon from "@mui/icons-material/Close";

import Button from "src/components/core/Button";
// import TextField from "src/components/core/TextField";

const WrapperBox = styled.div`
  width: 100%;
  margin-top: 16px;
`;

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    // paddingBottom: 0,
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
}));

const SelectDateDialog = ({ onClose, currentDate, callbackDate }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    if (!!currentDate) {
      setSelectedDate(new Date(currentDate));
    }
  }, [currentDate]);

  const onSubmit = async () => {
    callbackDate(selectedDate.toISOString());
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 400,
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          p: 3,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            borderRadius: "50%",
            border: "1px solid var(--lightgrey-color)",
            position: "absolute",
            right: 16,
            top: 16,
            color: "var(--primary-color)",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pb: 0,
          width: "100%",
          position: "relative",
          "& .MuiBox-root": {
            // maxWidth: "530px",
            mx: "auto",
          },
        }}
      >
        <WrapperBox>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="schedule date"
              format="DD/MM/YYYY - hh:mm A"
              value={dayjs(selectedDate)}
              onChange={(newValue) => {
                setSelectedDate(new Date(newValue.$d));
              }}
              sx={{
                width: "100%",
              }}
              slotProps={{ textField: { variant: "outlined" } }}
              minDateTime={dayjs(new Date())}
              maxDate={dayjs(new Date()).add(7, "day")}
              shouldDisableDate={(day) =>
                dayjs(day).day() === 0 || dayjs(day).day() === 6
              }
            />
          </LocalizationProvider>
        </WrapperBox>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 4 }}>
        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit()}
          sx={{
            width: "100%",
            maxWidth: 140,
            borderRadius: 4,
          }}
        >
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectDateDialog;
